import { SnippetsOutlined } from '@ant-design/icons'

export default {
  id: 'system_report',
  routerPrefix: '/system_report',
  icon: SnippetsOutlined,
  reactRoot: () => import('.')
}
